import { render, staticRenderFns } from "./teamReport.vue?vue&type=template&id=18cfdc7d&scoped=true"
import script from "./teamReport.vue?vue&type=script&lang=js"
export * from "./teamReport.vue?vue&type=script&lang=js"
import style0 from "./teamReport.vue?vue&type=style&index=0&id=18cfdc7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cfdc7d",
  null
  
)

export default component.exports